import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

//https://reactdatepicker.com/
import 'react-datepicker/dist/react-datepicker.css';

import "./date-range-picker-wrapper.css";

class DateRangePickerWrapper extends React.Component {
  constructor (props) {
    super(props);

    var dti;
    var dtf;
    if(props.dti && props.dtf){
      const dtiArr = props.dti.split('/');
      const dtiFormated = dtiArr[2]+'-'+dtiArr[1]+'-'+dtiArr[0];
      dti = dtiFormated;
      const dtfArr = props.dtf.split('/');
      const dtfFormated = dtfArr[2]+'-'+dtfArr[1]+'-'+dtfArr[0];
      dtf = dtfFormated;
    }
    
    this.state = {
      startDate: dti ? moment(dti) : moment(),
      endDate: dtf ? moment(dtf) : moment()
    };
    this.handleChangeStart = this.handleChangeStart.bind(this);
    this.handleChangeEnd = this.handleChangeEnd.bind(this);
  }

  handleChangeStart(date) {
    this.setState({
      startDate: date
    });
  }
  handleChangeEnd(date) {
    this.setState({
      endDate: date
    });
  }

  render() {
    return (

      <div>
        <div className="pure-u-12-24">
          <div className="box-input box-input--date">
              <div className="box-input--title">{this.props.titleDateInicio}</div>
              <div className="box-input--border">
                <div className="box-input--inner">
                  <DatePicker
                      name='dti'
                      dateFormat="DD/MM/YYYY"
                      selected={this.state.startDate}
                      selectsStart
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      onChange={this.handleChangeStart}
                  />
                </div>
              </div>
          </div>
        </div>
        <div className="pure-u-12-24">
          <div className="box-input box-input--date">
              <div className="box-input--title">{this.props.titleDateFim}</div>
              <div className="box-input--border">
                <div className="box-input--inner">
                  <DatePicker
                      name='dtf'
                      dateFormat="DD/MM/YYYY"
                      selected={this.state.endDate}
                      selectsEnd
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      onChange={this.handleChangeEnd}
                  />
                </div>
              </div>
          </div>
        </div>
    </div>
    );
  }
}

export default DateRangePickerWrapper;



// WEBPACK FOOTER //
// ./src/components/form/DateRangePickerWrapper.js